import { getUrlFromEnv } from "../../../services/api/config/utils/getUrlFromEnv";
import type { EditorValue } from "../../../services/api/instances/editorApi/types";
import type { ModelsValue } from "../../../services/api/instances/modelsApi/types";
import { getSubstringAfterFixedPart } from "../../../shared/utils/objectStorageModels";
import { StorageServiceVersions } from "../../../app/state/storageObjectSlice/types";

export const getModelUrl = (
  models: ModelsValue,
  spaObject: EditorValue,
): string => {
  const serverType = models.models.find(
    (model) => model.model_name === spaObject.spa_object?.preset?.model_name,
  )?.server_type;
  const chatUrl = models.servers.find(
    (server) => server.server_type === serverType,
  )?.chat_complections_url;
  const baseUrl = getUrlFromEnv("REACT_APP_BASE_URL");
  return getSubstringAfterFixedPart(chatUrl as string, baseUrl);
};

export const extractMiddlePart = (str: string) => {
  const match = str.match(/^spa-(.*?)-\d+$/);
  return match ? match[1] : "";
};

export const getPublishedSpaVersionId = (spa: EditorValue) => {
  const spaRef = spa?.spa_object?.uri_object?.publish?.ref;
  return spaRef?.split(":ID_")[1];
};

export const getPublishSpaVersion = (
  selectedId: string,
  versions: StorageServiceVersions,
  version: EditorValue,
) => {
  const versionId = getPublishedSpaVersionId(version);
  return versions[selectedId]?.find((item) => item.version_id === versionId);
};

export const readFileAsText = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target?.result as string);
    reader.onerror = () => reject(new Error("Ошибка чтения файла"));
    reader.readAsText(file, "UTF-8");
  });
};
